import queryString from 'query-string'
import { filterQueryParams } from '@/utils'
import { DispensationAPI } from './types'
import { base64Encode, decamelizeKeys } from '@/utils'

export const dispensationApi: DispensationAPI = ky => {
  return {
    async fetch({ patientId, year, isoYear }) {
      const params = decamelizeKeys(filterQueryParams({ year, isoYear }))

      return ky(`patient/${patientId}/dispensation/`, {
        method: 'get',
        searchParams: queryString.stringify(params)
      }).json()
    },

    async fetchOne({ patientId, dispensationId }) {
      return ky(`patient/${patientId}/dispensation/${dispensationId}/`, {
        method: 'get'
      }).json()
    },

    async create({ patientId, payload }) {
      return await ky(`patient/${patientId}/dispensation/`, {
        method: 'post',
        body: JSON.stringify(payload)
      }).json()
    },

    async update({ patientId, dispensationId, payload }) {
      return await ky(`patient/${patientId}/dispensation/${dispensationId}/`, {
        method: 'put',
        body: JSON.stringify(payload)
      }).json()
    },

    async patch({ patientId, dispensationId, payload }) {
      return await ky(`patient/${patientId}/dispensation/${dispensationId}/`, {
        method: 'patch',
        body: JSON.stringify(payload)
      }).json()
    },

    async delete({ patientId, dispensationId }) {
      await ky(`patient/${patientId}/dispensation/${dispensationId}/`, {
        method: 'delete'
      })
    },

    async uploadQR({ patientId, data, regular }) {
      return await ky(`patient/${patientId}/dispensation/qrcode/`, {
        method: 'post',
        body: JSON.stringify({ data: await base64Encode(data), regular })
      }).json()
    }
  }
}
